 <template>
   <div class="reservation">
     <div class="columns is-centered">
       <div class="column is-half">
         <div class="logo">
           <img src="/img/agtran_logo.png" alt="">
         </div>
         <div class="header">
           <h1 class="title">Hi, {{reservation.first_name}}!</h1>
         </div>
         <div class="card reservation-card">
           <div class="card-content">
             <div class="columns">
               <div class="column">
                 <p class="label">Reservation ID</p>
                 <p class="value">{{reservation.code}}</p>
               </div>
               <div class="column">
                 <p class="label">Vehicle</p>
                 <p class="value">{{reservation.maker}} {{reservation.model}}</p>
                 <p>*Equivalent or larger capacity vehicle might be given</p>
               </div>
             </div>
             <div class="columns">
               <div class="column">
                 <div class="item">
                   <p class="label">Name</p>
                   <p class="value">{{reservation.first_name}} {{reservation.last_name}}</p>
                 </div>
               </div>
               <div class="column">
                 <div class="item">
                   <p class="label">IC/Passport</p>
                   <p class="value">{{reservation.ic_num}}</p>
                 </div>
               </div>
             </div>
             <div class="columns">
               <div class="column">
                 <div class="item">
                   <p class="label">From</p>
                   <p class="value">{{from}}</p>
                 </div>
               </div>
               <div class="column">
                 <div class="item">
                   <p class="label">To</p>
                   <p class="value">{{to}}</p>
                 </div>
               </div>
             </div>
             <div class="columns">
               <div class="column">
                 <div class="item payment">
                   <p class="label">Payment</p>
                    <p class="value">RM{{reservation.net_total}} (Paid)</p>
                   <!--<a class="button is-primary" @click="sign()">Pay Now</a>-->
                 </div>
               </div>
             </div>
             <div class="columns">
               <div class="column">
                 <div class="item signature">
                   <p class="label">Signature</p>
                   <div class="form-check" v-if="!reservation.agreement_signature">
                    <input class="form-check-input" 
                        type="checkbox" 
                        v-model="agreetoTnC" 
                        value="" id="termsAndConditions">
                    <label class="form-check-label" for="termsAndConditions">
                      I agree to the <router-link to='/tnc'>Terms and Agreements.</router-link>
                    </label>
                   </div>
                   <p class="value" v-if="reservation.agreement_signature">All good! You already sign.</p>
                   <br>
                   <button class="button is-primary" :disabled="!agreetoTnC" v-if="reservation.agreement_signature == null" @click="sign()">Sign Here!</button>
                 </div>
               </div>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
 </template>
 <script>
  import { CONFIG } from "../config";
  import { mapState } from 'vuex'
  import { format } from "date-fns";

   export default {
     data() {
       return {
         name: 'Amirul',
         agreetoTnC: false
       }
     },
     created() {
     },
     methods: {
       sign() {
         this.$router.push('/signature')
       }
     },
     computed: {
       ...mapState(['reservation']),
       from() {
         return format(this.reservation.pick_up_date_time, 'D MMMM YYYY HH:mm A')
       },
       to() {
         return format(this.reservation.drop_off_date_time, 'D MMMM YYYY HH:mm A')
       }
     }
   }
 </script>
 <style lang="scss" scoped>
   .reservation {
     padding: 1em;
   }

   .header {
     margin: 1em 0 2em 0;
     text-align: left;
   }

   .logo {
     margin: 1em 0em 2em 0em;
   }

   .card {
     border-radius: 15px;
     box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2)
   }

   .card-footer {
     border-bottom-left-radius: 15px;
     border-bottom-right-radius: 15px;
   }

   .card-content {
     padding: 2em;
     text-align: left;
   }

   .card-footer-item {
     background: #ff2352;
     color: white;
     border-bottom-left-radius: 15px;
     border-bottom-right-radius: 15px;
   }

   .reservation-card {
     .value {
       font-size: 1.5em;
     }
   }

   .signature {
     text-align: center;
   }

   .payment {
     text-align: center;

     .value {
       margin-bottom: 0.5em;
     }
   }

   .card-content .column {
     border-bottom: 1px solid silver;
   }

   .card-content {
     .columns:last-child {
       .column {
         border-bottom: 0px solid silver;

       }
     }
   }
 </style>